var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"engine-container"},[(_vm.validUrl)?_c('iframe',{staticClass:"w-100 h-100",attrs:{"src":_vm.validUrl,"frameborder":"0","allow":"clipboard-read; clipboard-write"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }